import { createAsyncThunk } from "@reduxjs/toolkit";

import { getOrganization } from "../../../api/organizations";
import { getApiErrorMessage } from "../../../utils/apiErrorMessage";

export const loadOrganizationData = createAsyncThunk(
  "organization/fetch",
  async (organizationId, { rejectWithValue }) => {
    try {
      return await getOrganization(organizationId);
    } catch (error: unknown) {
      console.error(error);
      // Siempre un string en el store: `data.message` puede ser el
      // diccionario de errores del serializer.
      return rejectWithValue(
        getApiErrorMessage(error, "No pudimos cargar la organización."),
      );
    }
  },
);
